import { observable, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Form, { FormActions, FormBody, IconButton, SelectInput, SwitchInput, TextInput } from '../../Form';
import Modal from '../../Modal';

@inject('reportingTemplateStore', 'metaDataStore', 'parameterStore')
@observer
class ColumnSelect extends React.Component {

  @observable item = {
    label: '',
    seq: '',
    type: '',
    key: '',
    precision: 2,
    agg_period: null,
    agg_period_hour: null,
    agg_method: null,
    agg_offset: 0,
    group_by_period: 0,
    group_period_format: '',
    max_missing_values: 95,
    missing_data_symbol: '-',
    agg_type: '',
    equation_parameters: [],
    equation: '',
  }

  @observable enableAggregation = false;
  @observable offsetUnit = 0;
  @observable customHoursTime = null
  @observable aggPeriodHour = null

  timeUnitOptions = [
    { label: 'Point', value: 0 },
    { label: 'Minutes', value: 1 },
    { label: 'Hours', value: 60 },
    { label: 'Days', value: 1440 },
  ];

  customTimeUnitOptions = [
    { label: 'Hours' },
    { label: 'Days' },
  ];

  onChange = (e, field) => {
    let value = e.target.value
    this.item[field] = value;
    if (field === 'type' && +e.target.value !== 3) this.onToggleEnableAggregation(false);

    if (field.trim() == 'agg_period_hour') {
      if (this.customHoursTime == 'Days' && (value < 0 || value > 29)) {
        value = Math.max(0, Math.min(29, value));
      } else if (this.customHoursTime == 'Hours' && (value < 0 || value > 23)) {
        value = Math.max(0, Math.min(23, value));
      } else if (this.customHoursTime == 'Days' && (value > 0 &&  value <= 29)) {
          this.item.agg_period_hour = this.item.agg_period_hour * 24
      }  
       this.aggPeriodHour = value
    }
  }
  onChangeOffset = e => this.item.agg_offset = +e.target.value * +this.offsetUnit
  onChangeOffsetUnit = e => {
    this.offsetUnit = +e.target.value;
    if (!this.offsetUnit) this.item.agg_offset = 0;
  }

  onToggleEnableAggregation = (value = undefined) => {
    this.enableAggregation = value === undefined ? !this.enableAggregation : value;
    if (!this.enableAggregation) {
      this.item.agg_method = null;
      this.item.agg_period = null;
      this.item.max_missing_values = null;
      this.item.agg_type = null;
      this.item.group_by_period = null;
    }
  }

  onChangeCustomHoursTime = (e) => {
    this.customHoursTime = e.target.value;
    this.aggPeriodHour = 0
    this.item.agg_period_hour = 0
    if (this.customHoursTime == 'Days' && this.item.agg_period_hour <= 29) {
     this.item.agg_period_hour = this.item.agg_period_hour * 24;
   } else if (this.customHoursTime == 'Hours' && this.item.agg_period_hour <= 23) {
     this.item.agg_period_hour =  this.item.agg_period_hour;
   }
   
 }
 

  componentWillMount() {
    const { metaDataStore, parameterStore, column } = this.props;
    if (!metaDataStore.items.length && !metaDataStore.isLoading) metaDataStore.fetchItems();
    if (!parameterStore.items.length && !parameterStore.isLoading) parameterStore.fetchItems();

    if (!!column) {
      Object.keys(column).map(key => {

        if (key === 'equation_parameters') this.item[key] = (column[key] || '').split(',').map(id => ({ id }));
        else this.item[key] = column[key] || '';

        if (key === 'agg_offset' && +!!column[key]) {
          let offset = +column[key];
          if (offset > 0 && offset < 60) this.offsetUnit = 1;
          else if (offset >= 60 && offset < 1440) this.offsetUnit = 60;
          else if (offset >= 1440) this.offsetUnit = 1440;
          else this.offsetUnit = 0;
        }

        if (key == 'agg_period_hour' && +!!column[key]) {
          let value = +column[key]
          if (value > 23) {
            this.customHoursTime = 'Days'
            this.aggPeriodHour = value / 24
          }
           else { 
            this.customHoursTime = 'Hours'
            this.aggPeriodHour = value
          }
        }
      });

     

      this.enableAggregation = (!!column.agg_method && !!column.agg_period) || ([6, 7].includes(+this.item.agg_method));
    }
  }

  _renderSelect = (label, { items, isLoading }) => (
    <SelectInput label={label} value={this.item.key} onChange={e => this.onChange(e, 'key')} options={items} isLoading={isLoading} fields={{ label: 'name', value: 'id' }} />
  )

  _renderText = (label, placeholder) => (
    <TextInput label={label} value={this.item.key} placeholder={placeholder} onChange={e => this.onChange(e, 'key')} />
  )

  _renderKeySelect = type => {
    const { metaDataStore, parameterStore } = this.props;

    if (+type === 2) return this._renderSelect('Meta Data', metaDataStore);
    else if (+type === 3) return this._renderSelect('Parameter', parameterStore);
    else if (+type === 6 || +type === 8) return this._renderText(
      <div>
        Date Format
        <a href='https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/' target='_blank' rel="noopener noreferrer"><i className='fa fa-question-circle' style={{ color: '#3c8dbc', fontSize: '15px' }} /></a>
      </div>, 'YYYY-MM-DD HH:mm:ss')
    else return null;
  }

  _renderAggregationFields = () => {
    const { reportingTemplateStore } = this.props;
    const dischargeSelected = [6, 7].includes(+this.item.agg_method);

    return (<div className='bordered indented-form'>
      <SelectInput
        label={'Aggregation Method'}
        fields={{ label: 'name', value: 'id' }}
        options={reportingTemplateStore.aggregationMethodOptions}
        onChange={e => this.onChange(e, 'agg_method')}
        value={this.item.agg_method}
        sortBy='id'
      />
      {!dischargeSelected && <SelectInput
        label={'Aggregation Period'}
        fields={{ label: 'name', value: 'id' }}
        options={reportingTemplateStore.aggregationPeriodOptions}
        onChange={e => this.onChange(e, 'agg_period')}
        value={this.item.agg_period}
        sortBy='id'
      />}
      {/* {this.item.agg_period === 5 && <TextInput label='Aggregation Period Hour' value={this.item.agg_period_hour} onChange={e => this.onChange(e, 'agg_period_hour')} />} */}
      {
      this.item.agg_period === 5 &&  <div className='formInput flex flex-row'>
        <label>Aggregation Peroid Hour</label>
        {<input type="number" min= {this.customHoursTime == 'Days' ? 0 : 0} max={this.customHoursTime == 'Days' ? 29 : 23} value={this.aggPeriodHour} onChange={e => this.onChange(e, 'agg_period_hour')}  style={{ minWidth: '100px', width: '100px' }} disabled = {!this.customHoursTime}/> }
        <SelectInput id='offset-unit' label='' small value={this.customHoursTime} onChange={e => this.onChangeCustomHoursTime(e)} options={this.customTimeUnitOptions} fields={{ label: 'label', value: 'label' }} />
      </div>
      }
      {!dischargeSelected && <SelectInput
        label={'Aggregation Type'}
        fields={{ label: 'name', value: 'id' }}
        options={reportingTemplateStore.aggregationTypeOptions}
        onChange={e => this.onChange(e, 'agg_type')}
        value={this.item.agg_type}
      />}
      <SwitchInput label='Group By Period' value={!!+this.item.group_by_period} onChange={() => this.item.group_by_period = ~this.item.group_by_period + 2} />
      {!!+this.item.group_by_period && <TextInput
        label={<div>
          Group period format
          <a href='https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/' target='_blank' rel="noopener noreferrer"><i className='fa fa-question-circle' style={{ color: '#3c8dbc', fontSize: '14px' }} /></a>
        </div>}
        value={this.item.group_period_format}
        onChange={e => this.onChange(e, 'group_period_format')}
      />}
      <div className='formInput flex flex-row'>
        <label>Aggregation Offset</label>
        {+this.offsetUnit === 0 ?
          <input type="text" value={0} readOnly style={{ minWidth: '100px', width: '100px' }} /> :
          <input type="text" value={this.item.agg_offset / this.offsetUnit} onChange={this.onChangeOffset} style={{ minWidth: '100px', width: '100px' }} />}

        <SelectInput id='offset-unit' label='' small value={this.offsetUnit} onChange={this.onChangeOffsetUnit} options={this.timeUnitOptions} fields={{ label: 'label', value: 'value' }} />
        {/* <select value={this.offsetUnit} onChange={this.onChangeOffsetUnit} style={{ marginLeft: '10px' }}>
          {this.timeUnitOptions.map(option => (
            <option
              key={`offset-option-${option.value}`}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select> */}
      </div>
      <TextInput type='number' label={'Max missing values (%)'} value={this.item.max_missing_values} onChange={e => e.target.value > 0 && e.target.value <= 100 && this.onChange(e, 'max_missing_values')} />
      <TextInput label={'Missing data symbol'} value={this.item.missing_data_symbol} onChange={e => this.onChange(e, 'missing_data_symbol')} />
    </div>)
  }

  _renderEquationFields = () => {
    const { columns } = this.props;
    return <div className='bordered indented-form fit-content'>
      {this.item.equation_parameters.map((parameter, i) => {
        return (
          <div key={`p${i + 1}`} className='flex flex-row v-center'>
            <SelectInput label={`p${i}`} value={parameter.id} onChange={e => parameter.id = e.target.value} options={(columns || []).filter(item => item.type === 3)} fields={{ label: 'label', value: 'label' }} />
            <IconButton icon='fa fa-close' onClick={() => this.item.equation_parameters.remove(parameter)} />
          </div>
        )
      })}
      <span className='button button-inactive' onClick={() => this.item.equation_parameters.push({ id: '' })}>Add Parameter</span>
      <TextInput label={'Equation'} value={this.item.equation} onChange={e => this.onChange(e, 'equation')} />
    </div>
  }

  render() {
    const { onClose, onAddColumn, onUpdateColumn, reportingTemplateStore } = this.props;
    return (
      <Modal title={!!onAddColumn ? 'Add Column' : 'Update Column'} closeModal={onClose} slug=''>
        <Form>
          <FormBody>
            <TextInput label={'Label'} value={this.item.label} onChange={e => this.onChange(e, 'label')} />
            <SelectInput label={'Type'} value={this.item.type} onChange={e => this.onChange(e, 'type')} options={reportingTemplateStore.columnTypes} fields={{ label: 'name', value: 'id' }} />
            {this._renderKeySelect(this.item.type)}
            {[3, 7].indexOf(this.item.type) > -1 && <TextInput type='number' label={'Precision'} value={this.item.precision} onChange={e => this.onChange(e, 'precision')} key='precision' />}
            {this.item.type === 3 && <SwitchInput label='Aggregate' value={this.enableAggregation} onChange={() => this.onToggleEnableAggregation()} key='aggregate' />}
            {this.enableAggregation && this._renderAggregationFields()}
            {this.item.type === 7 && this._renderEquationFields()}
          </FormBody>

          <FormActions>
            <button onClick={(e) => {
              e.preventDefault();
              (onAddColumn || onUpdateColumn)(Object.assign({}, toJS(this.item), { equation_parameters: this.item.equation_parameters.map(item => item.id).join(',') }));
              onClose();
            }}>{!!onAddColumn ? 'Add' : 'Update'}</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default ColumnSelect;


// WEBPACK FOOTER //
// ./src/components/DataDelivery/ReportingTemplate/ColumnSelect.js